import { render, staticRenderFns } from "./OverlayLoginRegister.vue?vue&type=template&id=c9c634b6&"
import script from "./OverlayLoginRegister.vue?vue&type=script&lang=js&"
export * from "./OverlayLoginRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9c634b6')) {
      api.createRecord('c9c634b6', component.options)
    } else {
      api.reload('c9c634b6', component.options)
    }
    module.hot.accept("./OverlayLoginRegister.vue?vue&type=template&id=c9c634b6&", function () {
      api.rerender('c9c634b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/OverlayLoginRegister.vue"
export default component.exports